import { BillingAPIType, AuthUserType } from "../../../Actions/Types"
import { Reducer } from "redux"
import { AuthAction } from "../../Auth"
import {
    APIInvoiceModel,
    APIPaymentMethodModel
} from "../../../Models/API/BillingModel"

export interface BillingState {
    invoice: {
        list: APIInvoiceModel[]
    }
    paymentMethod: {
        list?: APIPaymentMethodModel[]
    }
}

interface IBillingAction {
    type: BillingAPIType | null
    payload?: {
        invoiceList?: APIInvoiceModel[] | null
        paymentMethodList?: APIPaymentMethodModel[] | null
    }
}

export type BillingAction = IBillingAction

const initialState: BillingState = {
    invoice: {
        list: []
    },
    paymentMethod: {
        list: undefined
    }
}

export const BillingReducer: Reducer<BillingState, BillingAction | AuthAction> =
    (state = initialState, action): BillingState => {
        switch (action.type) {
            case BillingAPIType.invoices_setList:
                return action.payload &&
                    action.payload.invoiceList !== undefined
                    ? {
                          ...state,
                          invoice: {
                              ...state.invoice,
                              list:
                                  action.payload.invoiceList !== null
                                      ? action.payload.invoiceList
                                      : []
                          }
                      }
                    : state
            case BillingAPIType.paymentMethod_setList:
                return action.payload &&
                    action.payload.paymentMethodList !== undefined
                    ? {
                          ...state,
                          paymentMethod: {
                              ...state.paymentMethod,
                              list:
                                  action.payload.paymentMethodList !== null
                                      ? action.payload.paymentMethodList
                                      : []
                          }
                      }
                    : state
            case AuthUserType.signedOut:
                return initialState
            default:
                return state
        }
    }
